import { c as createModalInstance } from "../modal-9a6b802d.mjs";
import { d as defineVuesticPlugin } from "../../../services/vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../../services/vue-plugin/utils/global-properties-9524ee5b.mjs";
const createVaModalPlugin = (app) => ({
  init(options) {
    return createModalInstance(options, app == null ? void 0 : app._context);
  }
});
const VaModalPlugin = defineVuesticPlugin(() => ({
  install(app) {
    defineGlobalProperty(app, "$vaModal", createVaModalPlugin(app));
  }
}));
export {
  VaModalPlugin as V
};
//# sourceMappingURL=index-970b6716.mjs.map
